import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Konfirmasi from '@/views/Konfirmasi/Konfirmasi.vue';
import CekKendaraan from '@/views/CekData/CekKendaraan.vue';
import Briva from '@/views/Briva.vue';
import PoskoEtle from '@/views/PoskoEtle.vue';
import FAQ from '@/views/FAQ.vue';
import DataPelanggaran from '@/views/CekData/DataPelanggaran.vue';
import DetailPelanggaran from '@/views/CekData/DetailPelanggaran.vue';
import notFound from '@/views/Konfirmasi/notFound.vue';
import Pelanggaran from '@/views/CekPelanggaran/Pelanggaran.vue';
import Faq from '@/views/FAQ/Faq.vue';
import DaftarKonfirmasiASDP from '@/views/PelanggaranASDP/DaftarKonfirmasiASDP.vue';


Vue.use(Router);

export default new Router({
   linkActiveClass: 'active-link',
   mode: 'history',
   // Vue CLI otomatis expose publicPath (env PUBLIC_PATH kita) sebagai
   // process.env.BASE_URL — tanpa ini, mode 'history' selalu pakai base
   // "/" sehingga navigasi klien & refresh di rute manapun selain "/"
   // 404 di belakang Traefik PathPrefix.
   base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/not-found',
      name: 'notFound',
      component: notFound,
    },
    {
      path: '/konfirmasi',
      name: 'Konfirmasi',
      component: Konfirmasi
    },
    {
      path: '/konfirmasi/:refNumber/plates/:plate',
      name: 'KonfirmasiDetail',
      component: Konfirmasi,
      meta: { hideFooter: true }
    },
    {
      path: '/cek-data',
      name: 'CekKendaraan',
      component: CekKendaraan,
      meta: { hideFooter: true }
    },
    {
      path: '/briva',
      name: 'Briva',
      component: Briva,
      meta: { hideFooter: true }
    },
    // {
    //   path: '/faq',
    //   name: 'FAQ',
    //   component: FAQ,
    //   meta: { hideFooter: true }
    // },
    {
      path: '/posko-etle',
      name: 'PoskoEtle',
      component: PoskoEtle,
      meta: { hideFooter: true }
    },
    {
      path: '/data-pelanggaran',
      name: 'DataPelanggaran',
      component: DataPelanggaran,
      props: true,
      meta: { hideFooter: true }
    },
    {
      path: '/detail/:plat_number',
      name: 'DetailPelanggaran',
      component: DetailPelanggaran,
      props: true,
      meta: { hideFooter: true }
    },
    {
      path: '/cek-pelanggaran',
      name: 'Pelanggaran',
      component: Pelanggaran,
      meta: { hideFooter: true }
    },
    {
      path: '/Faq',
      name: 'FAQ',
      component: Faq
    },
        {
      path: '/daftar-konfirmasi-asdp',
      name: 'DaftarKonfirmasiAsdp',
      component: DaftarKonfirmasiASDP,
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});
